import React from 'react';
import PropTypes from 'prop-types';
import { Form, Dropdown, Label, Image } from 'semantic-ui-react';

import { ReduxFormField, ReduxFormFieldCheckPopup } from 'components';

import classNames from 'classnames/bind';
import styles from './ReduxFormCommon.css';
const cx = classNames.bind(styles);

const renderField = ({ input, meta, checkType, validate, warn, className, errorMessage, ...rest }) => {
  return (
    <Form.Field className={className}>
      <Dropdown
        name={input.name}
        onFocus={input.onFocus}
        // onBlur 이벤트에 인자를 제대로 연결 시 blur 에 의해 value 가 없어질 수 있음
        // redux-form 에서는 보통 touched 조건 성립만이 필요함
        onBlur={e => input.onBlur()}
        {...rest}
        onChange={(e, data) => {
          input.onChange(data.value);
        }}
        error={rest.error || false}
        className={rest.error ? 'validate-error' : ''}
        icon={null}
      />
      <div className={cx('dropdown-arrow', { open: meta.active })} />

      {rest.error ? (
        <Label className="pointing-label" basic pointing>
          {/* 훈련 실시에서 태그의 경우 에러 메세지와 name값이 달라서 errorMessage를 넘겨준다 */}
          {errorMessage ? errorMessage : meta.error}
        </Label>
      ) : null}
      <ReduxFormFieldCheckPopup checkType={checkType} {...meta} />
    </Form.Field>
  );
};

const ReduxFormSemanticDropdown = ({ ...rest }) => {
  return <ReduxFormField component={renderField} {...rest} />;
};

ReduxFormSemanticDropdown.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  checkType: PropTypes.number
};
ReduxFormSemanticDropdown.defaultProps = {
  checkType: 99
};

export default ReduxFormSemanticDropdown;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormSemanticDropdown.js